import React, { useEffect } from "react";
import "./Page.css";
import useStore from "../store.js";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import Button from "../components/Button/Button.js";
import { useNavigateWithVars } from "../hooks/useNavigateWithVars";

import CharacterCard from "../components/CharacterCard/CharacterCard.js";

const CharactersPage = (props) => {
  const getLocalized = useStore((state) => state.getLocalized);
  const game = useStore((state) => state.game);
  const uid = useStore((state) => state.uid);
  const isHost = useStore((state) => state.isHost);
  const sessionData = useStore((state) => state.sessionData);
  const setGameState = useStore((state) => state.setGameState);
  const gameState = useStore((state) => state.gameState);
  const checkAllCharactersCheckedIn = useStore(
    (state) => state.checkAllCharactersCheckedIn,
  );

  const navigateTo = useNavigateWithVars();

  // const [allCharactersCheckedIn, setAllCharactersCheckedIn] = useState(false);
  const allCharactersCheckedIn = useStore(
    (state) => state.allCharactersCheckedIn,
  );

  // Check characters when page loads or sessionData changes
  useEffect(() => {
    if (sessionData && game) {
      checkAllCharactersCheckedIn();
    }
  }, [sessionData, game, checkAllCharactersCheckedIn]);

  console.log(
    "Characters",
    getLocalized("game", "Characters"),
    "All Checked In:",
    allCharactersCheckedIn,
  );

  if (!isHost)
    return <BlocksRenderer content={getLocalized("texts", "NoHost")} />;
  return (
    <div
      className={`Page Characters${
        props.className ? " " + props.className : ""
      }`}
    >
      <h1>
        {gameState == -1
          ? getLocalized("texts", "Vorbereitungen")
          : getLocalized("texts", "Rollen")}
      </h1>
      {gameState == -1 && (
        <div>
          {getLocalized("game", "WelcomeText") && (
            <>
              <BlocksRenderer content={getLocalized("game", "WelcomeText")} />
              <br />
              <hr />
            </>
          )}
          <BlocksRenderer content={getLocalized("texts", "RollenText")} />
          {getLocalized("game", "RollenTextOptional") && (
            <BlocksRenderer
              content={getLocalized("game", "RollenTextOptional")}
            />
          )}
        </div>
      )}
      <div className="Roles">
        {getLocalized("game", "Characters")?.data?.map((role, index) => {
          const r = role.attributes;
          r.id = role.id;
          return <CharacterCard key={index} role={r} />;
        })}
      </div>
      {allCharactersCheckedIn && gameState === -1 && (
        <Button className="full" onClick={() => setGameState(0)}>
          <BlocksRenderer content={getLocalized("texts", "SpielStarten")} />
        </Button>
      )}
      {!allCharactersCheckedIn && (
        <BlocksRenderer
          content={getLocalized("texts", "NichtAlleAngemeldet")}
        />
      )}
      {props.children}
    </div>
  );
};

export default CharactersPage;
